export class Shape1D {
}
//# sourceMappingURL=Shape1D.js.map